import { render } from "./RemediationTasks.vue?vue&type=template&id=4763759b&scoped=true&ts=true"
import script from "./RemediationTasks.vue?vue&type=script&lang=ts"
export * from "./RemediationTasks.vue?vue&type=script&lang=ts"

import "./RemediationTasks.vue?vue&type=style&index=0&id=4763759b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4763759b"]])

export default __exports__